import React from 'react';
import PropTypes from 'prop-types';
import FetchPublicApiComponent from '../../../../common/atoms/FetchPublicApiComponent';

class BaseSearchBox extends FetchPublicApiComponent {
  // max-age(Cookieの秒単位の有効期限)は90日を秒数で指定
  static MAX_AGE_OF_LOCATION = '7776000';

  constructor (props) {
    super(props);
    this.state = {
      isActive: false,
      isDiseaseModalActive: false,
      isAreaModalActive: false,
      isCurretLocationLoading: false,
      isSearchLoading: false,
      prefectureData: [],
      prefectureDataLoading: true,
      departmentSection: {},
      departmentSectionLoading: true,
      selectedType: this.convertInstitutionType(this.props.institutionType), // 'mixed', 'hospital', 'clinic', 'dental
      selectedDisease: {
        name: this.props.diseaseName || '',
        code: this.props.diseaseCode || ''
      },
      selectedPrefecture: this.initialSelectedPrefecture(),
      selectedCity: this.initialSelectedCity(),
      selectedStation: {
        name: this.props.stationName || '',
        code: this.props.stationCode || '',
        lineName: this.props.stationLineName || ''
      },
      selectedDepartment: {
        name: this.props.departmentName || '',
        code: this.props.departmentCode || ''
      },
      selectedCampaignCode: {
        name: this.getCampaignCodeNameByCode(this.props.featureHospitalSearch?.campaign_code) || '',
        code: this.props.featureHospitalSearch?.campaign_code || ''
      },
      selectedArea: '',
      keyword: this.props.keyword,
      selectedCampaignCodeSearchFilterNames: this.props.campaignCodeSearchFilterNames || [],
      campaignCodeSearchFilterNamesChoices: this.props.featureHospitalSearch?.campaign_code_search_filters || []
    };
    this.tooltipOpen = this.tooltipOpen.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.tooltipRef = React.createRef();
    this.scrollTop = this.scrollTop.bind(this);
    this.openAreaModal = this.openAreaModal.bind(this);
    this.openDiseaseModal = this.openDiseaseModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onClickSearch = this.onClickSearch.bind(this);
    this.fetchPrefectureData = this.fetchPrefectureData.bind(this);
    this.fetchDepartmentSection = this.fetchDepartmentSection.bind(this);
  }

  componentDidMount () {
    document.addEventListener('click', this.handleClickOutside);
    this.fetchPrefectureData();
    this.fetchDepartmentSection();
  }

  componentWillUnmount () {
    document.removeEventListener('click', this.handleClickOutside);
  }

  fetchPrefectureData () {
    const apiLocation = '/public/api/prefectures';
    this
      .fetch(apiLocation)
      .then(data => {
        this.setState(
          {
            prefectureData: data.data,
            prefectureDataLoading: false
          }
        );
      });
  }

  fetchDepartmentSection () {
    const apiLocation = '/public/api/departments';
    this
      .fetch(apiLocation)
      .then(data => {
        this.setState(
          {
            departmentSection: data.data,
            departmentSectionLoading: false
          }
        );
      });
  }

  initialSelectedPrefecture = () => {
    const { prefectureName, prefectureCode } = this.props;

    // 都道府県を指定せず検索した場合、prefectureNameには「全国」が入り、prefectureCodeはnullになるため、prefectureCodeには空文字を設定する。
    if (prefectureName && !prefectureCode) {
      return { name: prefectureName, code: '' };
    }

    return {
      name: prefectureName || this.getCookie('prefectureName'),
      code: prefectureCode || this.getCookie('prefectureCode')
    };
  };

  initialSelectedCity = () => {
    const { cityName, cityCode, prefectureName } = this.props;

    if (cityCode) {
      return { name: cityName, code: cityCode };
    }

    // 都道府県のみ選択されている場合は、Cookieに保存されている市区町村情報は設定しない
    if (prefectureName) {
      return { name: '', code: '' };
    }

    return {
      name: this.getCookie('cityName'),
      code: this.getCookie('cityCode')
    };
  }

  getCookie = (key) => {
    const cookies = document.cookie;
    const cookiesArray = cookies.split(';');
    const targetCookie = cookiesArray.find((item) => {
      return item.trim().split('=')[0] === key;
    });
    const val = targetCookie?.split('=')[1];

    return val ? decodeURIComponent(val) : '';
  }

  getCampaignCodeNameByCode = (code) => {
    return this.props.campaignCodesToDisplay.find((campaignCode) => campaignCode.code === code)?.name || null;
  }

  tooltipOpen (event) {
    event.stopPropagation(); // クリックイベントがバブルアップするのを防ぐ
    this.setState({ isActive: !this.state.isActive });
  }

  handleClickOutside (event) {
    if (this.tooltipRef.current && !this.tooltipRef.current.contains(event.target)) {
      this.setState({ isActive: false });
    }
  }

  handleCheckType = (event) => {
    this.setState({ selectedType: event.target.value });
  }

  scrollTop () {
    return Math.max(
      window.pageYOffset,
      document.documentElement.scrollTop,
      document.body.scrollTop);
  }

  closeModal (event) {
    this.setState({ isDiseaseModalActive: false, isAreaModalActive: false });
    if (event) event.preventDefault();
    const body = document.getElementsByTagName('body')[0];
    const scrollY = body.style.top;
    body.classList.remove('fixed');
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
    body.style.top = '';
  }

  openAreaModal () {
    const scrollPosition = this.scrollTop();
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('fixed');
    body.style.top = `${scrollPosition * -1}px`;
    this.setState({ isAreaModalActive: true });
  }

  openDiseaseModal () {
    const scrollPosition = this.scrollTop();
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('fixed');
    body.style.top = `${scrollPosition * -1}px`;
    this.setState({ isDiseaseModalActive: true });
  }

  handleSelectDisease = (disease) => {
    this.closeModal();
    this.setState({
      selectedDisease: disease,
      selectedDepartment: { name: '', code: '' },
      selectedCampaignCode: { name: '', code: '' },
      selectedCampaignCodeSearchFilterNames: [],
      campaignCodeSearchFilterNamesChoices: []
    });
  }

  handleSelectDepartment = (department) => {
    this.closeModal();
    this.setState({
      selectedDisease: { name: '', code: '' },
      selectedDepartment: department,
      selectedCampaignCode: { name: '', code: '' },
      selectedCampaignCodeSearchFilterNames: [],
      campaignCodeSearchFilterNamesChoices: []
    });
  }

  handleSelectCampaignCode = (campaignCode) => {
    this.closeModal();
    this.fetchCampaignCodeSearchFilters(campaignCode);
    this.setState({
      selectedDisease: { name: '', code: '' },
      selectedDepartment: { name: '', code: '' },
      selectedCampaignCode: campaignCode,
      selectedCampaignCodeSearchFilterNames: []
    });
  }

  fetchCampaignCodeSearchFilters = (campaignCode) => {
    const apiLocation = `/public/api/campaign_code_search_filters?campaign_code=${campaignCode.code}`;

    this
      .fetch(apiLocation)
      .then(response => {
        this.setState({
          campaignCodeSearchFilterNamesChoices: response.data || []
        });
      });
  }

  handleSelectPrefecture = (prefecture) => {
    this.setState({ selectedPrefecture: prefecture });
  }

  handleEntirePrefecture = () => {
    this.closeModal();
    this.setState({ selectedCity: {} });
  }

  handleSelectCity = (city) => {
    this.closeModal();
    this.setState({ selectedCity: city, selectedStation: {} });
  }

  handleSelectStation = (station) => {
    this.closeModal();
    this.setState({ selectedStation: station, selectedCity: {} });
  }

  handleSelectEntirePrefecture = () => {
    this.closeModal();
    this.setState({ selectedCity: {}, selectedStation: {} });
  }

  handleKeywordInput = (event) => {
    this.setState({ keyword: event.target.value });
  }

  handleCheckCampaignCodeSearchFilterNames = (event) => {
    const { selectedCampaignCodeSearchFilterNames } = this.state;
    const value = event.target.value;

    const updatedSearchFilterNames = selectedCampaignCodeSearchFilterNames.some(item => item.name === value)
      ? selectedCampaignCodeSearchFilterNames.filter(item => item.name !== value)
      : [...selectedCampaignCodeSearchFilterNames, { name: value }];

    this.setState({ selectedCampaignCodeSearchFilterNames: updatedSearchFilterNames });
  }

  changeCurrentLocationLoading = (isCurretLocationLoading) => {
    this.setState({ isCurretLocationLoading: isCurretLocationLoading });
  }

  setCurrentLocation = (prefecture, city) => {
    this.closeModal();
    this.setState({ selectedPrefecture: prefecture, selectedCity: city, isCurretLocationLoading: false });
  }

  selectedArea = () => {
    let area = '';

    if (this.state.selectedPrefecture?.name) {
      area += this.state.selectedPrefecture.name;

      if (this.state.selectedCity?.name && !this.state.selectedStation?.name) {
        area += this.state.selectedCity.name;
      } else if (this.state.selectedStation?.name) {
        area = `${this.state.selectedStation.name}（${this.state.selectedStation.lineName}）`;
      } else {
        area += '全域';
      }
    } else if (this.state.selectedStation?.name) {
      area = `${this.state.selectedStation.name}（${this.state.selectedStation.lineName}）`;
    }

    return area;
  }

  clearSearchFiltersAndSelections = () => {
    this.setState({
      selectedDisease: { name: '', code: '' },
      selectedDepartment: { name: '', code: '' },
      selectedCampaignCode: { name: '', code: '' },
      selectedCampaignCodeSearchFilterNames: [],
      campaignCodeSearchFilterNamesChoices: []
    });
  }

  clearSelectedArea = () => {
    this.setState({ selectedStation: { name: '' }, selectedCity: { name: '' }, selectedPrefecture: { name: '' } });
  }

  onClickSearch = (event) => {
    event.preventDefault();
    this.setState({ isSearchLoading: true });
    this.setCookiesOfArea();
    location.href = this.generateSearchUrl();
  }

  setCookiesOfArea = () => {
    const { selectedPrefecture, selectedCity, selectedStation } = this.state;

    // 都道府県が選択されていない、もしくは駅が選択されている場合、エリアでの検索がされていないため、Cookieの更新を行わない
    if (!selectedPrefecture?.code || selectedStation?.code) {
      return;
    }

    document.cookie = `prefectureCode=${selectedPrefecture.code}; max-age=${BaseSearchBox.MAX_AGE_OF_LOCATION}; path=/; Secure`;
    document.cookie = `prefectureName=${selectedPrefecture.name}; max-age=${BaseSearchBox.MAX_AGE_OF_LOCATION}; path=/; Secure`;

    if (selectedCity?.code) {
      document.cookie = `cityCode=${selectedCity.code}; max-age=${BaseSearchBox.MAX_AGE_OF_LOCATION}; path=/; Secure`;
      document.cookie = `cityName=${selectedCity.name}; max-age=${BaseSearchBox.MAX_AGE_OF_LOCATION}; path=/; Secure`;
    } else {
      document.cookie = 'cityCode=; max-age=0; path=/; Secure';
      document.cookie = 'cityName=; max-age=0; path=/; Secure';
    }
  }

  extractPrefecturePaths = () => {
    return this.state.prefectureData.reduce((acc, prefecture) => {
      prefecture.items.forEach(item => {
        acc[item.code] = item.path;
      });
      return acc;
    }, {});
  };

  convertInstitutionType = (institutionType) => {
    switch (institutionType) {
    case 'ho':
      return 'hospital';
    case 'c':
      return 'clinic';
    case 'd':
      return 'dental';
    default:
      // 'h'(病院+クリニック混在の一覧)およびハブページ(institutionType未指定)では、
      // 対象ラジオの既定選択を「病院・クリニック」にする
      return 'mixed';
    }
  };

  generateSearchUrl = () => {
    const paths = ['hospitals'];
    const {
      selectedType,
      selectedDisease,
      selectedDepartment,
      selectedPrefecture,
      selectedCity,
      selectedStation,
      selectedCampaignCode,
      keyword,
      selectedCampaignCodeSearchFilterNames
    } = this.state;

    // 種別の追加
    switch (selectedType) {
    case 'hospital':
      paths.push('ho');
      break;
    case 'clinic':
      paths.push('c');
      break;
    case 'dental':
      paths.push('d');
      break;
    case 'mixed':
    default:
      // 「病院・クリニック」選択時、または対象ラジオが未選択(混在)の場合は病院+クリニック混在の一覧へ
      paths.push('h');
      break;
    }

    // 都道府県が選択されている場合
    if (selectedPrefecture.code) {
      const { path, code } = selectedPrefecture;
      const prefecturePathNames = this.extractPrefecturePaths();
      path ? paths.push(path) : paths.push(prefecturePathNames[code]);
    }

    // 市区町村または駅が選択されている場合
    if (selectedCity.code) {
      paths.push(`CTY${selectedCity.code}`);
    } else if (selectedStation.code) {
      paths.push(`STN${selectedStation.code}`);
    }

    // 疾患・診療科・キャンペーンコードのいずれかが選択されている場合
    if (selectedDisease.code) {
      paths.push(`DIS${selectedDisease.code}`);
    } else if (selectedDepartment.code) {
      paths.push(`DEP${selectedDepartment.code}`);
    } else if (selectedCampaignCode.code) {
      paths.push(`CAM${selectedCampaignCode.code}`);
    }

    const url = '/' + paths.join('/');
    const params = new URLSearchParams();

    if (keyword?.length > 0) {
      params.append('keyword', keyword);
    }

    if (selectedCampaignCodeSearchFilterNames?.length > 0) {
      selectedCampaignCodeSearchFilterNames.forEach(item => {
        params.append('search_filter_names[]', item.name);
      });
    }

    const queryString = params.toString();
    return queryString ? `${url}?${queryString}` : url;
  }
}

BaseSearchBox.propTypes = {
  campaignCodesToDisplay: PropTypes.array.isRequired,
  carbonHost: PropTypes.string.isRequired,
  searchCondition: PropTypes.object,
  institutionType: PropTypes.string,
  prefectureCode: PropTypes.string,
  prefectureName: PropTypes.string,
  cityCode: PropTypes.string,
  cityName: PropTypes.string,
  stationCode: PropTypes.string,
  stationName: PropTypes.string,
  stationLineName: PropTypes.string,
  diseaseCode: PropTypes.string,
  diseaseName: PropTypes.string,
  departmentCode: PropTypes.string,
  departmentName: PropTypes.string,
  keyword: PropTypes.string,
  position: PropTypes.string,
  diseaseList: PropTypes.array,
  featureHospitalSearch: PropTypes.object,
  campaignCodeSearchFilterNames: PropTypes.array
};

export default BaseSearchBox;
